<template>
  <div class="home" style="min-height: 75vh">
    <starter/>
    <customers/>
    <products-snip/>
    <services/>
  </div>
</template>

<script>
// @ is an alias to /src


import Starter from "../components/home/starter";
import Customers from "../components/home/customers";
import Services from "../components/home/services";
import ProductsSnip from "../components/home/products";
export default {
  name: 'Home',
  components: {
    ProductsSnip,
    Services,
    Customers,
    Starter

  }
}
</script>
